import { appFor } from '../../content/appLinks'
import { trackEvent } from '../../lib/analytics'

// The two store badges, using APPLE’S AND GOOGLE’S OWN ARTWORK.
//
// public/badges/app-store.svg came from developer.apple.com and
// public/badges/google-play.png from play.google.com/intl/en_us/badges. Both
// companies require their supplied badge rather than a redrawn one, and both
// have clear-space and minimum-height rules: the Apple badge must not be
// altered or recoloured, and the Play badge keeps clear space of at least a
// quarter of its height on every side. The heights below (40px, scaled from the
// supplied art) satisfy both.
//
// ⛔ Do not swap these for hand drawn SVGs. An approximation of someone else’s
// trademark is both off-brand for them and a guideline breach for us.
//
// ⚠️ EQUAL INKED HEIGHT, not equal file height. Google's supplied badge carries
// 41px of clear space baked into all four sides of a 646x250 file, so its actual
// mark is 67% of the image: at the same CSS height it rendered a THIRD smaller
// than Apple's, which is what the founder spotted. The file is trimmed to its
// ink (564x168) and both now sit at 44px, so they match. Google's guidelines
// still want clear space around the badge; the layout gap provides it, which is
// what the gap is for.
//
// ⛔ NO "coming soon" CAPTION (founder 2026-10-02). This site is built as though
// it is live on release day. A disclaimer under the badges is an instruction
// manual talking about our rollout, and nobody came here to read about our
// rollout. `listed` still drives where the links POINT, which is the part that
// has to be true.

// ⚠️ ALWAYS APPLE'S BLACK BADGE, including over photography, and that is not an
// oversight. Apple ships a white cut as well, but it is TRANSPARENT with black
// lettering: over a hero photograph the type competes with whatever is behind it
// and the badge half disappears. Google ships ONE badge and it is dark. Pairing
// Apple's white with Google's dark also looked like two different brands had
// been glued together, because that is what it was.
//
// Both badges dark, side by side, is what every app does, and both companies'
// guidelines allow their badge over imagery as long as the clear space is kept.
// `tone` still controls the CAPTION colour, which does change by background.
export default function StoreBadges({ audience = 'work', source = 'web', tone = 'dark', className = '' }) {
  const app = appFor(audience)


  const click = (store) => () => trackEvent('app_store_click', { store, audience, source })

  return (
    <div className={className}>
      <div className="flex flex-wrap items-center gap-3">
        <a
          href={app.ios}
          onClick={click('ios')}
          target="_blank"
          rel="noreferrer"
          aria-label={`Download ${app.name} on the App Store`}
        >
          <img src="/badges/app-store.svg" alt="Download on the App Store" width="135" height="45" className="block h-[44px] w-auto" />
        </a>
        <a
          href={app.android}
          onClick={click('android')}
          target="_blank"
          rel="noreferrer"
          aria-label={`Get ${app.name} on Google Play`}
        >
          <img src="/badges/google-play.png" alt="Get it on Google Play" width="148" height="44" className="block h-[44px] w-auto" />
        </a>
      </div>
    </div>
  )
}
